 import {observable, action, computed} from "mobx"
import axios from "axios"

class EntreeStore{
  @observable rdv = {}
  @observable bien = {}
  @observable ordremission={}
  @observable entree={}
  @observable pieces = []
  @observable dones = []
  @observable modepc = true

  @action setRdv(rdv){
    this.rdv = rdv
    this.loadPieces()
  }
  @computed get loaded(){
    if(this.rdv=={}){
      return false
    }else{
      return true
    }
  }
  @action loadPieces(){
    axios.post("/api/v1/experts/app/entree/loadPieces",{id: this.rdv.id}).then((data)=>{
      this.pieces = data.data.pieces
      this.dones = data.data.done
    })
  }


}

let store = new EntreeStore()
global.EntreeStore = store
export default store
